var render, staticRenderFns
import script from "./AsyncRender.vue?vue&type=script&lang=js"
export * from "./AsyncRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df75e9e",
  null
  
)

export default component.exports